import { createContext } from 'react';
import { STEPS } from '../constants';

export const FormStepContext = createContext({
    step: STEPS.BUSIENSS,
    formState: {},
    setStep : () => {},
    updateFormState : () => {},
    submitForm : () => {},
});